import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ReviewOverrideRequest {
  finalDecision: string;
  overrideReason: string;
}

export interface ReviewLog {
  id: number;
  architectName: string;
  architectId?: string;
  action: string;
  timestamp: string;
  originalAiRecommendation: string;
  finalDecision: string;
  overrideReason?: string;
}

export interface AssessmentReviewStatus {
  isFinalized: boolean;
  finalizedBy?: string;
  finalizedAt?: string;
  finalDecision?: string;
  isAiGenerated: boolean;
  originalAiRecommendation?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ModernizationReviewService {
  private readonly baseUrl = `${environment.apiUrl}/modernization`;

  constructor(private http: HttpClient) {}

  /**
   * Accept AI recommendation without changes (finalize & lock)
   */
  acceptRecommendation(sysId: string): Observable<AssessmentReviewStatus> {
    return this.http.post<AssessmentReviewStatus>(
      `${this.baseUrl}/${sysId}/review/accept`,
      {}
    );
  }

  /**
   * Override AI recommendation with architect decision (requires reason)
   */
  overrideRecommendation(
    sysId: string,
    request: ReviewOverrideRequest
  ): Observable<AssessmentReviewStatus> {
    return this.http.post<AssessmentReviewStatus>(
      `${this.baseUrl}/${sysId}/review/override`,
      request
    );
  }

  /**
   * Get approval history/logs for an assessment
   */
  getApprovalLogs(sysId: string): Observable<ReviewLog[]> {
    return this.http.get<ReviewLog[]>(
      `${this.baseUrl}/${sysId}/review/logs`
    );
  }
}
